import useScreenBreakpoint from "@hooks/useScreenBreakpoint";
import React from "react";
import { sendEventEmptyStateClick } from "@services/dashboardAnalyticEventService";
import { dashboardChartEmptyStatesTypes } from "@utils/constants/dashboard/analyticDashboardEvents";
import EmptyStateMagnifyingGlass from "@svg/illustration/EmptyStateMagnifyingGlass";

import {
  EmptyStateWrapper,
  MobileEmptyStateWrapper,
  MobileTextWrapper,
  StyledHeading,
  StyledLinkButton,
  StyledText,
  TextWrapper,
} from "./style";
import { ChartIdentificationType } from "@customTypes/chart";

type DashboardSplitChartEmptyStateProps = {
  title: string | React.ReactNode;
  subtitle: string;
  chartId: ChartIdentificationType;
  mobileText: string;
  link: string;
};

const DashboardSplitChartEmptyState: React.FC<DashboardSplitChartEmptyStateProps> = ({
  title,
  subtitle,
  chartId,
  mobileText,
  link,
}) => {
  const { isMobileScreen } = useScreenBreakpoint();

  const sendMixPanelWhenClickToHelpCenter = () => {
    sendEventEmptyStateClick(dashboardChartEmptyStatesTypes.HELP_CENTER, chartId);
  };

  const LinkButton = () => (
    <StyledLinkButton onClick={sendMixPanelWhenClickToHelpCenter} href={link} target="_blank" link>
      Saiba mais sobre este gráfico
    </StyledLinkButton>
  );

  return isMobileScreen ? (
    <MobileEmptyStateWrapper>
      <EmptyStateMagnifyingGlass />
      <MobileTextWrapper>
        <StyledText size="sm" color="gray500">
          {mobileText}
        </StyledText>
        <LinkButton />
      </MobileTextWrapper>
    </MobileEmptyStateWrapper>
  ) : (
    <EmptyStateWrapper>
      <TextWrapper>
        <StyledHeading size="xs" semiBold>
          {title}
        </StyledHeading>
        <StyledText size="md">{subtitle}</StyledText>
      </TextWrapper>
      <LinkButton />
    </EmptyStateWrapper>
  );
};

export default DashboardSplitChartEmptyState;
